import { CgHome, CgProfile, CgQr } from "react-icons/cg";
import { TbCalendarSearch } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { path: "/loggedinartistbussiness", label: "Home", icon: CgHome },
  { path: "/businessQr", label: "QR Code", icon: CgQr },
  { path: "/businessCalendar", label: "Calendar", icon: TbCalendarSearch },
  { path: "/businessProfile", label: "Profile", icon: CgProfile },
];

export default function MobileNBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav className="md:hidden w-full max-w-md mx-auto grid grid-cols-4 fixed z-20 bottom-0 left-0 right-0 bg-white px-2 py-1 shadow-lg rounded-t-xl border-t border-gray-100">
      {navItems.map(({ path, label, icon: Icon }) => {
        const isActive = currentPath === path;
        return (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            onTouchEnd={() => navigate(path)} // 👈 ensures instant response
            className={`flex flex-col items-center cursor-pointer focus:outline-none transition-colors ${
              isActive ? "text-logo" : "text-gray-500 hover:text-gray-700"
            }`}
          >
            <div className={`p-2 rounded-full ${isActive ? "bg-logo/20" : ""}`}>
              <Icon className="text-xl" />
            </div>
            <span className="text-xs font-medium mt-1">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
